import { Service_zfb_xf_move_member_key } from "@/service/platform_config";
import { createVNode } from "vue";
import { Modal } from "ant-design-vue";
import { WarningOutlined } from "@ant-design/icons-vue";
import MallGroupApi from "@/api/zfb/mall_group";
import AuthApi from "@/api/zfb/auth";
import { Service_Tb1688FxAppKey } from "@/service/tb_1688_service";
import { getResourceList } from "@/api/zfb/resource";
import { mapMutations } from "vuex";
// 获取该店铺授权的应用
async function GetAuthAppList(page, size, relationId) {
  return await AuthApi.GetAuthAppList(page, size, relationId, Service_Tb1688FxAppKey);
}
// 获取资源列表 appType    1-一键下单   2-上货助手
const GetResourceList = async (appType) => {
  const { result } = await getResourceList(appType);
  for (let item of result.resourceList) {
    item.AppTypeStr = item.AppTypeStr.replace("上货助手", "搬家上货");
    if (item.ResourceType === 1) {
      item.ResourceTypeStr = "顶部广告图";
    } else if (item.ResourceType === 4) {
      item.ResourceTypeStr = "首次进入展示图片";
    }
  }
  const state = mapMutations({
    setNavList: "xfadmin/setNavList",
  });
  console.log(state);
  return { resourceList: result.resourceList, navList: result.navList };
};
// 退出用户操作
function LogOut(cb) {
  Modal.confirm({
    icon: createVNode(WarningOutlined),
    content: `您确定要退出账号吗?`,
    okText: "确定",
    cancelText: "取消",
    onOk: () => {
      localStorage.clear(Service_zfb_xf_move_member_key);
      cb();
    },
  });
}
// 获取店群内所有的店铺
async function GetMallListByGroupId(page, size, GroupId) {
  return await MallGroupApi.GetMallListByGroupId(page, size, GroupId);
}
export default { LogOut, GetMallListByGroupId, GetAuthAppList, GetResourceList };
